export const gameTypeIsBetBuilder = (gameTypeId: number) => {
	return gameTypeId === -9600 || gameTypeId === -9601 || gameTypeId === 9600;
};
